<div class="resize-fill" layout="column" flex-wrap="false">
	<div flex *ngIf="!webcast.layout.isFullscreenVideo && !fillVideo" class="d-none d-md-block theme-primary-bg">
		<div layout="row" navbar-padding="100" flex-justify="center" flex-align="center" [ngClass]="styles.header" class="theme-primary-txt theme-primary-font-border-fade-50">
			<div flex="fill">{{ 'Event_Webcast_Region_Video' | translate }}</div>
			<vb-webcast-vod-timer *ngIf="webcast.isVodSource" [webcast]="webcast" (onTimerEnd)="onTimerEnd()">
			</vb-webcast-vod-timer>
		</div>
	</div>

	<live-stream-status *ngIf="(webcast.startingVideoSource || webcast.waitingForVideoSource)
			&& webcast.enableLiveStreamStatusDisplay" [webcast]="webcast">
	</live-stream-status>

	<div [ngClass]="[styles.videoHeightContainer, fillVideo ? styles.focusVideo : '']" flex-justify="center" flex-align="stretch" layout="column" layout-padding="100" vbWatchDimensions [padding]="fillVideo ? 0 : 32" (dimensionsChanged)="height=$event.height;width=$event.width" *ngIf="!(webcast.startingVideoSource || webcast.waitingForVideoSource || disposePlayer)">
		<div class="width-full height-full" flex="fill" flex-align="center" flex-justify="center" layout>

			<div class="fixed-ratio-wrapper webcast-video-not-supported" [hidden]="webcast.playbacks?.length" [ngClass]="[
					webcast.playbacks?.length ? 'mobile-hide-for-real' : styles.videoWrapper
				]" [ngStyle]="{
					'height': (height) + 'px',
					'width': (width) + 'px'
				}">
				<div class="webcast-video fixed-ratio">

					<div class="text-center" [hidden]="webcast.isUpdatingPlaybacks">
						{{ 'Video_Playback_StreamNotAvailable' | translate }}
					</div>
					<vb-loading-spinner [hidden]="!webcast.isUpdatingPlaybacks" [block]="true" [size]="'large'">
					</vb-loading-spinner>
				</div>

			</div>

			<div [ngClass]="styles.videoWrapper" class="height-full" flex-align="center" [hidden]="!(webcast.playbacks?.length)">

				<ng-container *ngIf="(isPlayerContext$ | async) as playerContext">
					<vb-webcast-vod-preview *ngIf="playerContext.isVodPreview" [webcast]="webcast" [height]="height" [width]="width">
					</vb-webcast-vod-preview>
					<div *ngIf="!playerContext.isVodPreview" [ngStyle]="{
							'height': (height) + 'px',
							'width': (width) + 'px'
						}" vb-webcast-player [playbacks]="webcast.playbacks" [playerConfig]="playerConfig" [webcastId]="webcast.id" [webcast]="webcast" [runNumber]="webcast.currentRun.runNumber" [webcastSessionId]="webcast.currentUser.sessionId" [heartbeatIntervalSecs]="webcast.videoHeartbeatInterval" [videoOverlays]="webcast.videoOverlays" [bannerDetails]="webcast.bannerDetails" [reactionCfg]="reactionCfg" [title]="webcast.title" (onPlayerReady)="onPlayerReadyInternal($event)" (onWmvFullscreenToggled)="onFullscreenToggled($event.isFullscreen)" (onPlayerSizeChanged)="onPlayerSizeChanged($event)" [autoPlay]="webcast.autoplay" [isVcSource]="webcast.dualPlaybackSource" [isCaptionsAvailable]="webcast.closedCaptionsEnabled" slideDelay [activeSource]="vgAPI?.activeSource" [canControlSlides]="webcast.currentUser.canControlPresentationSlides" [currentState]="vgAPI?.currentState" [presentation]="webcast.presentation" [viewContext]="viewContext" [webcastPlaybacks]="webcast.playbacks">
					</div>
				</ng-container>
			</div>

		</div>
	</div>
</div>
